import {
  clearSafeTimeout,
  scheduleSafeTimeout,
} from 'dashboard/helper/browserTimers';

const state = {
  message: '',
  type: 'success',
  visible: false,
  timeout: null,
};

const getters = {
  getMessage: ($state) => $state.message,
  getType: ($state) => $state.type,
  getVisible: ($state) => $state.visible,
};

const mutations = {
  SET_NOTIFICATION($state, { message, type }) {
    $state.message = message;
    $state.type = type;
    $state.visible = true;
  },
  CLEAR_NOTIFICATION($state) {
    $state.visible = false;
  },
};

const actions = {
  show(
    { commit, state: $state },
    { message, type = 'success', duration = 3000 }
  ) {
    // Clear any existing timeout
    if ($state.timeout) {
      clearSafeTimeout($state.timeout);
      $state.timeout = null;
    }

    // Show notification
    commit('SET_NOTIFICATION', { message, type });

    // Auto-hide after duration
    $state.timeout = scheduleSafeTimeout(() => {
      commit('CLEAR_NOTIFICATION');
      $state.timeout = null;
    }, duration);
  },

  hide({ commit, state: $state }) {
    if ($state.timeout) {
      clearSafeTimeout($state.timeout);
      $state.timeout = null;
    }
    commit('CLEAR_NOTIFICATION');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
